import { render } from "./AddInfoFooter.vue?vue&type=template&id=c338dc36&ts=true"
import script from "./AddInfoFooter.vue?vue&type=script&lang=ts"
export * from "./AddInfoFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__